import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * Moves a record saved for the first time from /new to its own path.
 *
 * Only from /new: elsewhere a stored id that is not in the path is the record
 * before, still in the store while the next one loads, and following it sent
 * the user back to the supplier they had just left (#2326 R-243).
 */
export const useRedirectAfterNewSave = (basepath: string, id?: number) => {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const newPath = basepath.replace(':id', 'new');
        const onNewPath = location.pathname === newPath || location.pathname.startsWith(newPath + '/');

        if (id && onNewPath) {
            navigate(basepath.replace(':id', id.toString()), { replace: true });
        }
    }, [basepath, id, navigate, location]);
};
